module.exports = __webpack_public_path__ + "media/images/ic-location-pin-222b8705c26ace4c0e6b70e71b735bae.svg";